import { useEffect, useRef, useState } from 'react'
import { checkFace } from '@/services/player'
import SJButton from '@/components/SJButton'
import icons from '@/assets/icons'
// import images from "@/assets/images";
import { Toast } from 'antd-mobile'
import { sleep } from 'antd-mobile/es/utils/sleep'
// import user from "@/stores/user";
import { uploadImageEncrypt } from '@/services/file'
// import DetectRTC from 'detectrtc'
import './index.less'

type Props = {
  onSuccess: (faceId: string) => void
  onCancel: () => void
}

const SJTakeFace = ({ onSuccess, onCancel }: Props) => {
  const [file, setFile] = useState('')
  const [warn, setWarn] = useState('')
  const [position, setPosition] = useState<'front' | 'back'>('front')

  const isPhoto = useRef<boolean>(false) // 是照片
  const video = useRef<any>(null)
  const canvas = useRef<any>(null)
  const MediaStreamTrack = useRef<any>(null)

  useEffect(() => {
    getMedia()
    return () => {
      clearMedia()
    }
  }, [])

  /* const initMedia = () => {
    DetectRTC.load(() => {
      console.log('DetectRTC.hasWebcam', DetectRTC.hasWebcam)
      console.log(
        'DetectRTC.isWebsiteHasWebcamPermissions',
        DetectRTC.isWebsiteHasWebcamPermissions,
      )
      if (DetectRTC.hasWebcam && DetectRTC.isWebsiteHasWebcamPermissions) {
        getMedia()
      } else {
        Dialog.confirm({
          title: '提示',
          content: '需要您允许使用摄像头',
          // cancelText: '以后再说',
          confirmText: '好的',
          onConfirm: () => getMedia(),
        })
      }
    })
  } */

  const clearMedia = () => {
    if (MediaStreamTrack.current) {
      MediaStreamTrack.current.stop()
      MediaStreamTrack.current = null
    }
  }

  const getMedia = (pos: 'front' | 'back' = 'front') => {
    clearMedia()
    setPosition(pos)
    let constraints = {
      video: {
        width: 340,
        height: 340,
        facingMode: pos === 'front' ? 'user' : 'environment',
      },
      audio: false,
    }
    // 获得video摄像头区域
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((MediaStream: MediaStream | any) => {
        console.log(MediaStream.getTracks())
        MediaStreamTrack.current =
          typeof MediaStream.stop === 'function' ? MediaStream : MediaStream.getTracks()[0] // 可能多个摄像头
        if ('srcObject' in video.current) {
          // 有些旧浏览器没有srcObject
          video.current.srcObject = MediaStream
          // video.current.setAttribute('playsinline', true) // ios 摄像头唤醒不成功,ios不回自动播放，需要在<video>标签上直接设置
        } else {
          video.current.src = window.URL.createObjectURL(MediaStream)
          // video.current.setAttribute('playsinline', true)
        }
        video.current.onloadedmetadata = () => {
          video.current.play()
        }
        isPhoto.current = false
      })
      .catch((err) => {
        if (err) {
          console.log('需要您允许使用摄像头')
          Toast.show(err)
          // Explain why you need permission and how to update the permission setting
        }
      })
  }
  //拍照
  const takePhoto = () => {
    if (isPhoto.current) {
      getMedia()
      clearCanvas()
      isPhoto.current = false
    } else {
      //获得Canvas对象
      let ctx = canvas.current.getContext('2d')
      // 左右镜像翻转
      ctx.translate(340, 0)
      ctx.scale(-1, 1)
      ctx.drawImage(video.current, 0, 0, 340, 340)
      MediaStreamTrack.current && MediaStreamTrack.current.stop()
      setFile(canvas.current.toDataURL('image/jpeg'))
      isPhoto.current = true
    }
  }

  /**
   * @description 重置canvas（清除照片）
   * @version 1.0
   * @returns
   */
  const clearCanvas = () => {
    if (canvas.current) {
      /* eslint-disable-next-line */
      canvas.current.height = canvas.current.height
    }
  }

  const handleConfirm = async () => {
    try {
      const res = (await uploadImageEncrypt(file, true)) as unknown as {
        objectname: string
      }
      const fileId = res.objectname
      check(fileId)
    } catch (error) {}
  }

  const check = async (faceId: string) => {
    try {
      await checkFace(faceId)
      Toast.show('检测成功')
      await sleep(2000)
      onSuccess(faceId)
    } catch (error: any) {
      setWarn(error.code === 500 ? '人脸检测失败，请重试' : error.message || '人脸检测失败，请重试')
    }
  }
  const handleRephotograph = () => {
    setFile('')
    setWarn('')
    takePhoto()
  }
  return (
    <div className="page take-face">
      <div className={`des ${warn ? 'warn' : ''}`}>{warn || '请保持人脸在取景框中间'} </div>
      <div className={`camera-wrap ${warn ? 'warn' : ''}`}>
        {!file && (
          <div
            className="camera-box hoverClass"
            onClick={() => {
              getMedia(position === 'back' ? 'front' : 'back')
            }}
          >
            <img className="icon-camera" src={icons.IconCamere} alt="" />
          </div>
        )}
        {/* playsInline ios必需 */}
        <video ref={video} width="340" height="340" autoPlay playsInline className="camera"></video>
        <canvas
          ref={canvas}
          className="canvas"
          width="340"
          height="340"
          style={{ zIndex: file ? 2 : 0 }}
        ></canvas>
      </div>
      {file ? (
        !warn ? (
          <div className="btns">
            <SJButton onClick={handleRephotograph}>重拍</SJButton>
            <SJButton type="primary" onClick={handleConfirm}>
              确认
            </SJButton>
          </div>
        ) : (
          <SJButton className="btn-add" size="large" onClick={handleRephotograph}>
            重拍
          </SJButton>
        )
      ) : (
        <SJButton className="btn-add" type="primary" size="large" onClick={takePhoto}>
          拍照
        </SJButton>
      )}
      <div className="jump" onClick={onCancel}>
        下次再说
      </div>
      {/* <div className='encrypted'>
        <div>图像信息将经过加密处理，系统不会存储人脸照片，且不会用于除机器人识别棋手以外的其他任何用途；</div>
        <div>14岁以下儿童需要在家长监护下完成信息采集。</div>
      </div> */}
    </div>
  )
}
export default SJTakeFace
